import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  type ButtonProps,
} from "@mui/material";

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  contentText?: string;
  title?: string;
  confirmLabel?: string;
  /** For non-destructive confirms (e.g. Unlink): softer color + own verb. */
  confirmColor?: ButtonProps["color"];
  pendingLabel?: string;
}

export function DeleteConfirmationModal({
  open,
  onClose,
  onConfirm,
  isPending,
  contentText = "Are you sure? This action cannot be undone.",
  title = "Delete Confirmation",
  confirmLabel = "Delete",
  confirmColor = "error",
  pendingLabel = "Deleting...",
}: DeleteConfirmationModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirmation-dialog-title"
      aria-describedby="delete-confirmation-dialog-description"
      slotProps={{
        paper: {
          sx: { borderRadius: 2, p: 8 },
        },
      }}
    >
      <DialogTitle id="delete-confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-confirmation-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={isPending}
          autoFocus
          startIcon={isPending ? <CircularProgress size={16} /> : null}
        >
          {isPending ? pendingLabel : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
